import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

const SESSION_KEY = 'backbar_mobile_report_mode'
export function useMobileReport() {
  const route = useRoute()
  const isMobileReportView = ref(false)
  const checkMobileStatus = () => {
    const isStored = sessionStorage.getItem(SESSION_KEY) === 'true'
    const hasQueryParam = route?.query?.mobile_report !== undefined && route?.query?.mobile_report !== 'false'
    if (isStored || hasQueryParam) {
      isMobileReportView.value = true
      if (!isStored) {
        sessionStorage.setItem(SESSION_KEY, 'true')
      }
    } else {
      isMobileReportView.value = false
    }
  }
  watch(
    () => route?.query,
    () => {
      checkMobileStatus()
    },
    { immediate: true, deep: true }
  )
  const showNavigation = computed(() => !isMobileReportView.value)
  return {
    isMobileReportView,
    showNavigation
  }
}